import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import {
  TemplateViewModel,
  GenericIdName,
  ImplementDetails,
  ObservationPointDetails,
  MeasurementPointDetails,
  SaveImplementImageParams,
  SchematicDataVM,
  ComponentVM,
  SaveImplementDetailParams,
  SaveMeasurementPointParams,
  SaveObservationPointParams,
  SaveComponentParams,
  SaveModeltParams,
  SchematicImagesVM,
  saveNewImplementTypeVM,
  SaveQuestionImageParams,
  ImplementMakeModelVM,
  GenericIdNameBudgetHours,
  getMethodSuccessResponse,
  ResultGetModelDiffMessage,
  ObservationPointVMEdit,
  ImplementInspectionAttachmentsVM,
  observationListVM,
  UpdateComponentVM,
  UpdateObsPointVM,
  UpdateQuestion,
  DeleteQuestion,
  DrawShape,
  ResponseMessage,
  Locations,
  CrackStatusVM,
  SchematicType,

} from './setup-implement.model';
import { UpdateObservationPointModal } from '../add-observation-point/add-observation-point-modal';
import { Tuple } from '../setup-equipment/setup-equipment.model';
import { componentListsVM, CrackObPointImagesVM, NormalObsPointHistroy } from '../equipment-details/equipment-details.model';
import { CopyComponentListVM, CopyImplmentVM } from './copy-implement-dialog/copy-implement-dialog.model';
import { UpdateInspectionImagePhotoViewModel } from '../inspections/inspection.model';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class SetupImplementService {
  constructor(private _http: Http, private _httpClient: HttpClient) { }

  public GetImplementMakes(): Observable<GenericIdName[]> {
    return this._http.get('api/Implement/GetImplementMakes').share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetImplementTypesForEquipment(equipmentId: number): Observable<TemplateViewModel[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/Implement/GetImplementTypesForEquipment', { search: params }).share().map(
      (response: Response) => <TemplateViewModel[]>response.json()).catch(this.handleError);
  }

  public GetComponentTypesForImplement(get_auto: number): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetComponentTypesForImplement', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetComponentTypeListForSelectedImplement(get_auto: number): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetComponentTypeListForSelectedImplement', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public getSchematicsAndTypes(implementId: number): Observable<SchematicType[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', implementId.toString());
    return this._http.get('api/Implement/GetSchematicsAndTypes', { search: params }).share().map(
      (response: Response) => <SchematicType[]>response.json()).catch(this.handleError);

  }


  public GetMasterComponentTypeList(get_auto: number): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetMasterComponentTypeList', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetTemplateListForUser(): Observable<TemplateViewModel[]> {
    let params: URLSearchParams = new URLSearchParams();
    return this._http.get('api/Implement/GetTemplateListForUser', { search: params }).share().map(
      (response: Response) => <TemplateViewModel[]>response.json()).catch(this.handleError);
  }

  //get-421
  public GetTemplateListForUserFilterByCustomer(customer_id: number): Observable<TemplateViewModel[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('customer_id', customer_id.toString());
    return this._http.get('api/Implement/GetTemplateListForUserFilterByCustomer', { search: params }).share().map(
      (response: Response) => <TemplateViewModel[]>response.json()).catch(this.handleError);
  }

  //GET-424
  public DeleteObservationPoint(op_id: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('observation_point_auto', op_id.toString());
    return this._http.get('api/Implement/deleteObservationPoint', { search: params }).share().map(
      (response: Response) => <getMethodSuccessResponse>response.json()).catch(this.handleError);
  }

  public deleteObservationPointFromInspection(implementInspectionId: number, observationPointId: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementInspectionId', implementInspectionId.toString());
    params.set('ObservationPointId', observationPointId.toString());
    return this._http.get('api/Implement/deleteObservationPointFromInspection', { search: params })
      .map((response: Response) => response.text())
      .catch(this.handleError);
  }

  public GetModelDiffMessage(equipment_id_source: number, equipment_id_dest: number): Observable<ResultGetModelDiffMessage> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipment_id_source', equipment_id_source.toString());
    params.set('equipment_id_dest', equipment_id_dest.toString());
    return this._http.get('api/Implement/GetModelDiffMessage', { search: params }).share().map(
      (response: Response) => <ResultGetModelDiffMessage>response.json()).catch(this.handleError);
  }

  public GetImplementsOnEquipment(equipmentId: number): Observable<GenericIdNameBudgetHours[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/Implement/GetImplementsOnEquipment', { search: params }).share().map(
      (response: Response) => <GenericIdNameBudgetHours[]>response.json()).catch(this.handleError);
  }

  public GetImplementsInInventory(jobsiteId: number): Observable<GenericIdNameBudgetHours[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('jobsiteId', jobsiteId.toString());
    return this._http.get('api/Implement/GetImplementsInInventory', { search: params }).share().map(
      (response: Response) => <GenericIdNameBudgetHours[]>response.json()).catch(this.handleError);
  }


  public GetImplementsInInventoryForModel(jobsiteId: number, model: string, equipmentId: number): Observable<ImplementMakeModelVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('jobsiteId', jobsiteId.toString());
    params.set('model', model);
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/Implement/GetImplementsInInventoryByModel', { search: params }).share().map(
      (response: Response) => <ImplementMakeModelVM[]>response.json()).catch(this.handleError);
  }

  public GetImplementDetails(getAuto: number): Observable<ImplementDetails> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/Implement/GetImplementDetails', { search: params }).share().map(
      (response: Response) => <ImplementDetails>response.json()).catch(this.handleError);
  }

  public LoadImplementImage(getAuto: number): Observable<string> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/Implement/LoadImplementImage', { search: params }).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public SaveImplementImage(params: SaveImplementImageParams) {
    return this._http.post('api/Implement/SaveImplementImage', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public DeleteImplementImage(params: SaveImplementImageParams) {
    return this._http.post('api/Implement/DeleteImplementImage', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }
  public ReturnGETComponents(getAuto: number): Observable<ComponentVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/GETComponent/ReturnGETComponents', { search: params }).share().map(
      (response: Response) => <ComponentVM[]>response.json()).catch(this.handleError);
  }

  public ReturnGETActiveComponents(getAuto: number): Observable<ComponentVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/GETComponent/ReturnGETActiveComponents', { search: params }).share().map(
      (response: Response) => <ComponentVM[]>response.json()).catch(this.handleError);
  }
  public ReturnGETSchematicComponents(getAuto: number, SchematicId: number): Observable<ComponentVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    params.set('SchematicId', SchematicId.toString());
    return this._http.get('api/GETComponent/ReturnGETComponents', { search: params }).share().map(
      (response: Response) => <ComponentVM[]>response.json()).catch(this.handleError);
  }
  public ReturnGETPurchaseCost(getAuto: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());

    return this._http.get('api/Implement/ReturnGETPurchaseCost', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);

    // return this._http.get('api/Implement/ReturnGETPurchaseCost', { search: params }).share().map(
    //     (response: Response) => <ComponentVM[]>response.json()).catch(this.handleError);
  }

  public GetMeasurementPointDetails(implementId: number, getAuto: number): Observable<MeasurementPointDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implement_auto', implementId.toString());
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/GETComponent/GetMeasurementPointDetails', { search: params }).share().map(
      (response: Response) => <MeasurementPointDetails[]>response.json()).catch(this.handleError);
  }

  public GetObservationLists(customerId: number, implementId: number): Observable<observationListVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('customerId', customerId.toString());
    params.set('implementId', implementId.toString());
    return this._http.get('api/GETComponent/GetObservationLists', { search: params }).share().map(
      (response: Response) => <observationListVM[]>response.json()).catch(this.handleError);
  }

  public GetObservationPointDetails(getAuto: number): Observable<ObservationPointDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    return this._http.get('api/GETComponent/GetObservationPointDetails', { search: params }).share().map(
      (response: Response) => <ObservationPointDetails[]>response.json()).catch(this.handleError);
  }

  public GetObservationPointTypes(): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    return this._http.get('api/ObservationPoint/GetObservationPointTypes', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetSchematicData(implementId: number): Observable<SchematicDataVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementId', implementId.toString());
    return this._http.get('api/Implement/GetSchematicDataForImplement', { search: params }).share().map(
      (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
  }

  public GetSchematicDataForEditObsevationPoint_(ObservationPOintID: number, get_auto: number): Observable<ObservationPointVMEdit[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ObservationPOintID', ObservationPOintID.toString());
    params.set('get_auto', get_auto.toString());
    return this._http.get("Api/Implement/GetSchematicDataForEditObsevationPoint", { search: params }).share().map(
      (response: Response) => <ObservationPointVMEdit[]>response.json()).catch(this.handleError);
  }
  public GetSchematicDataForEditObsevationPoint(ObservationPOintID: number): Observable<ObservationPointVMEdit[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ObservationPOintID', ObservationPOintID.toString());
    return this._http.get("Api/Implement/GetSchematicDataForEditObsevationPoint", { search: params }).share().map(
      (response: Response) => <ObservationPointVMEdit[]>response.json()).catch(this.handleError);
  }
  public SaveSchematicImageList(params: SchematicImagesVM): Observable<boolean> {
    return this._http.post('Api/Implement/SaveSchematicImages', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public SaveComponentType(params: GenericIdName): Observable<boolean> {
    return this._http.post('Api/Implement/SaveComponentTypes', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public UpdateImplement(params: SaveImplementDetailParams): Observable<number> {
    return this._http.post('api/Implement/UpdateImplement', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public SaveImplementType(params: saveNewImplementTypeVM): Observable<number> {
    return this._http.post('Api/Implement/saveImplementType', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public EditImplementSerial(params: GenericIdName): Observable<boolean> {
    return this._http.post('Api/Implement/EditImplementSerial', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public DeleteImplement(implementId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('getAuto', implementId.toString());
    return this._http.delete('api/Implement/DeleteImplement', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public CreateImplementSetupEvent(params: SaveImplementDetailParams): Observable<number> {
    return this._http.post('api/Implement/SetupEvent', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public ValidateImplementSerial(implementId: number, implementSerial: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementId', implementId.toString());
    params.set('implementSerial', implementSerial.toString());
    return this._http.get('api/Implement/ValidateImplementSerial', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public ValidateImplementSetupLTD(getAuto: number, implementLTD: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('getAuto', getAuto.toString());
    params.set('implementLTD', implementLTD.toString());
    return this._http.get('api/Implement/ValidateImplementSetupLTD', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public ValidateImplementSetupDate(getAuto: number, setupDate: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('getAuto', getAuto.toString());
    params.set('setupDate', setupDate.toString());
    return this._http.get('api/Implement/ValidateImplementSetupDate', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public ValidateEquipmentSMUAtSetup(getAuto: number, equipmentId: number, equipmentSMU: number, setupDate: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('getAuto', getAuto.toString());
    params.set('equipmentId', equipmentId.toString());
    params.set('equipmentSMU', equipmentSMU.toString());
    params.set('setupDate', setupDate.toString());
    return this._http.get('api/Implement/ValidateEquipmentSMUAtSetup', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public SaveMeasurementPoints(params: SaveMeasurementPointParams): Observable<number> {
    return this._http.post('api/GETComponent/SaveMeasurementPoints', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public SaveObservationPoints(params: SaveObservationPointParams): Observable<number> {
    return this._http.post('api/GETComponent/SaveObservationPoints', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public SaveComponents(params: SaveComponentParams): Observable<boolean> {
    return this._http.post('Api/GETComponent/SaveComponents', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public DeleteComponents(params: SaveComponentParams): Observable<boolean> {
    return this._http.post('Api/GETComponent/DeleteComponents', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public CheckhasCopyFrom(get_auto: number): Observable<boolean[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/CheckCopyFromBy', { search: params }).share().map(
      (response: Response) => <boolean[]>response.json()).catch(this.handleError);
  }

  public SaveImplementModelDetails(params: SaveModeltParams): Observable<boolean> {
    return this._http.post('Api/Implement/SaveImplementModelDetails', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public LoadSelectedModelsForImplementtType(implementType: number): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementType', implementType.toString());
    return this._http.get('api/Implement/LoadSelectedModelsForImplement', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public DeleteImplementSchematicImage(schematicId: number, implementId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('schematicId', schematicId.toString());
    params.set('implementId', implementId.toString());
    return this._http.get('api/Implement/DeleteImplementSchematicImage', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public CreateCopyBasedOnExistingImplement(existingImplement: number, newImplementSerialNo: string, equipmentId: number, jobsiteId: number,
    setupDate: string, implementHoursAtSetup: number, equipmentSMUAtSetup: number, hours: number, isCopyToTemplate: boolean): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('existingImplement', existingImplement.toString());
    params.set('newImplementSerialNo', newImplementSerialNo.toString());
    params.set('equipmentId', equipmentId.toString());
    params.set('jobsiteId', jobsiteId.toString());
    params.set('setupDate', setupDate.toString());
    params.set('implementHoursAtSetup', implementHoursAtSetup.toString());
    params.set('equipmentSMUAtSetup', equipmentSMUAtSetup.toString());
    params.set('hours', hours.toString())
    params.set('isCopyToTemplate', isCopyToTemplate.toString())

    console.log("CreateCopyBasedOnExistingImplement", params)
    return this._http.get('api/Implement/CreateCopyBasedOnExistingImplement', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public CreateCopyToExisitingImplement(CopyfromImplement: number, CopytoImplement: number,): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('CopyfromImplement', CopyfromImplement.toString());
    params.set('CopytoImplement', CopytoImplement.toString());
    return this._http.get('api/Implement/CreateCopyToExisitingImplement', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  //TT-4980

  public CreateCopyToExisitingImplementAdvanced(params: CopyImplmentVM) {
    return this._http.post('api/Implement/CreateCopyToExisitingImplementAdvanced', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }



  public CreateCopyBasedOnExistingImplementAdvanced(params: CopyImplmentVM) {
    return this._http.post('api/Implement/CreateCopyBasedOnExistingImplementAdvanced', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }
  //End TT-4980

  public UpdateObservationPointForAll(params: UpdateObservationPointModal) {
    return this._http.post('api/ObservationPoint/UpdateObservationPoint', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public UpdateObservationPointForThisImpl(params: UpdateObservationPointModal) {
    return this._http.post('api/ObservationPoint/UpdateObservationPoint', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public DeleteQuestionImage(params: SaveQuestionImageParams) {
    return this._http.post('api/Implement/DeleteQuestionImage', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public SaveQuestionImage(params: SaveQuestionImageParams) {
    return this._http.post('api/Implement/SaveQuestionImage', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public RemoveNewImplementType(ImplementTypeId: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementTypeId', ImplementTypeId.toString());
    return this._http.delete('api/Implement/RemoveNewImplementType', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public SaveDefaultImplementImage(implementId: number): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementId', implementId.toString());
    return this._http.get('api/Implement/SaveDefaultImplementImage', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }
  public UpdateSchmaticImageName(SchematicId: number, ImageName: string): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('SchematicId', SchematicId.toString());
    params.set('ImageName', ImageName);

    return this._http.get('api/Implement/UpdateSchmaticImageName', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public LoadNormalObsPointHistroy(componentId: number, obsPointId: number): Observable<NormalObsPointHistroy[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('componentId', componentId.toString());
    params.set('obsPointId', obsPointId.toString());
    return this._http.get('api/Implement/LoadNormalObsPointHistroy', { search: params }).share().map(
      (response: Response) => <NormalObsPointHistroy[]>response.json()).catch(this.handleError);
  }


  public LoadCrackObsPointHistroy(componentId: number, obsPointId: number): Observable<NormalObsPointHistroy[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('componentId', componentId.toString());
    params.set('obsPointId', obsPointId.toString());
    return this._http.get('api/Implement/LoadCrackObsPointHistroy', { search: params }).share().map(
      (response: Response) => <NormalObsPointHistroy[]>response.json()).catch(this.handleError);
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public UpdateObservationPoints(params: ObservationPointVMEdit): Observable<boolean> {
    return this._http.post('Api/Implement/UpdateObservationPoints', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GETComponentsAndObsPoints(getAuto: number): Observable<CopyComponentListVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', getAuto.toString());
    // return this._http.get<any>('api/GETComponent/GETComponentsAndObsPoints', { search: params }).share().map(
    //     (response: Response) => <ComponentVM[]>response.json()).catch(this.handleError);

    return this._http.get('api/GETComponent/GETComponentsAndObsPoints', { search: params }).share().map(
      (response: Response) => <CopyComponentListVM[]>response.json()).catch(this.handleError);

  }

  public LoadReplaceRepairComponent(implementId: number, EventId: number): Observable<NormalObsPointHistroy[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementId', implementId.toString());
    params.set('EventId', EventId.toString());
    return this._http.get('api/Implement/LoadReplaceRepairComponent', { search: params }).share().map(
      (response: Response) => <NormalObsPointHistroy[]>response.json()).catch(this.handleError);
  }

  public updateGETScematicImage(schmaticId: number, imageData: string) {
    const model = new UpdateInspectionImagePhotoViewModel();
    model.ImageId = schmaticId;
    model.ImageData = imageData;
    return this._http.post('api/Implement/ReplacedGETScematicImage', model)
      .share().map((response: Response) => <string>response.json()).catch(this.handleError);
  }


  public GetBuildNosForSelectedImplementType(ImpTypeId: number): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImpTypeId', ImpTypeId.toString());
    return this._http.get('api/Implement/GetBuildNosForSelectedImplementType', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }


  public GetImplementAttchDocTypes(): Observable<GenericIdName[]> {
    return this._http.get('api/Implement/GetAttachDocTypes').share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }


  public GetInspectionDocInfo(InspectionId: number): Observable<ImplementInspectionAttachmentsVM> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('InspectionId', InspectionId.toString());
    return this._http.get('api/Implement/GetInspectionDocInfo', { search: params }).share().map(
      (response: Response) => <ImplementInspectionAttachmentsVM>response.json()).catch(this.handleError);
  }

  /*public SaveImplementInspectionDocuments(params: ImplementInspectionAttachmentsVM) {
    return this._http.post('api/Implement/SaveImplementInspectionDocuments', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }*/

  public SaveImplementInspectionDocuments(params: ImplementInspectionAttachmentsVM) {
    return this._httpClient.post<boolean>('api/Implement/SaveImplementInspectionDocuments', params).pipe(catchError(this.handleError));
  }


  public saveCrackObservationPointImages(info: CrackObPointImagesVM): Observable<number> {
    return this._http.post('api/Implement/saveCrackObservationPointImages', info).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public EditCrackObservationPointImages(info: CrackObPointImagesVM): Observable<number> {
    return this._http.post('api/Implement/EditCrackObservationPointImages', info).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public deleteCrackObservationPointImages(info: CrackObPointImagesVM): Observable<number> {
    return this._http.post('api/Implement/deleteCrackObservationPointImages', info).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public SaveObservationPointSortDetailsAll(obsSortList: ObservationPointDetails[], ImplementID: number, cbApplyToAll: boolean): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementID', ImplementID.toString());
    params.set('cbApplyToAll', cbApplyToAll.toString());
    return this._http.post("api/GETComponent/SaveObservationPointSortDetailsAll", obsSortList, { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public updateSchematicComponentType(schematicID: number, componentTypeID: number, implementId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('schematicID', schematicID.toString());
    params.set('componentTypeID', componentTypeID.toString());
    params.set('ImplementId', implementId.toString());
    return this._http.get('api/GETComponent/updateSchematicComponentType', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public saveUpdateComponentType(ComponentTypeVM: SchematicDataVM[]): Observable<boolean> {
    // return this._http.post<boolean>('Api/GETComponent/saveUpdateComponentType', ComponentTypeVM).share().map(
    //     (response: Response) => <string>response.json()).catch(this.handleError);

    return this._http.post('Api/GETComponent/saveUpdateComponentType', ComponentTypeVM).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GetSchematicComponentType(schematicID: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('schematicID', schematicID.toString());
    return this._http.get("api/GETComponent/GetSchematicComponentType", { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public GetSchematicComponentTypeViewModelList(schematicID: number, implementId: number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('schematicID', schematicID.toString());
    params.set('ImplementId', implementId.toString());
    return this._http.get("api/GETComponent/GetSchematicComponentTypevmlist", { search: params }).share().map(
      (response: Response) => response.json()).catch(this.handleError);
  }


  public getColorCodes(): Observable<componentListsVM[]> {
    return this._http.get('api/GETComponent/getColorCodes').share().map(
      (response: Response) => <componentListsVM[]>response.json()).catch(this.handleError);
  }
  public getSeverityList(customerId: number): Observable<componentListsVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('customerId', customerId.toString());
    return this._http.get("api/GETComponent/getSeverityList", { search: params }).share().map(
      (response: Response) => <componentListsVM[]>response.json()).catch(this.handleError);
  }

  public getInspectionTypeList(): Observable<componentListsVM[]> {
    return this._http.get('api/GETComponent/getInspectionTypeList').share().map(
      (response: Response) => <componentListsVM[]>response.json()).catch(this.handleError);
  }

  public deleteSchematic(params: SchematicDataVM): Observable<boolean> {
    return this._http.post('Api/GETComponent/deleteSchematic', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


  public ReplaceSchematic(params: SchematicDataVM): Observable<boolean> {
    return this._http.post('Api/GETComponent/ReplaceSchematic', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GetAllComponents(implementId: number): Observable<string[]> {
    return this._http.get(`api/GETComponent/GetAllComponents/${implementId}`).share().map(
      (response: Response) => <string[]>response.json()).catch(this.handleError);
  }

  public UpdateComponentsForObservationPoints(params: UpdateComponentVM): Observable<boolean> {
    return this._http.post('api/GETComponent/UpdateComponentsForObservationPoints', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }
  public UpdateValuesForObservationPoints(params: UpdateObsPointVM): Observable<boolean> {
    return this._http.post('api/GETComponent/UpdateValuesForObservationPoints', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public UpdateQuestionInstructionsForObservationPoints(params: UpdateQuestion): Observable<boolean> {
    return this._http.post('api/GETComponent/UpdateQuestionInstructionsForObservationPoints', params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public DeleteQuestionInstructionsForObservationPoints(params: DeleteQuestion): Observable<boolean> {
    return this._http.delete('api/GETComponent/DeleteQuestionInstructionsForObservationPoints', {
      body: params
    }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }
  public GetCrackObsList(IsCrack: boolean, IsObsCrack: boolean, getAuto: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('IsCrack', IsCrack.toString());
    params.set('IsObsCrack', IsObsCrack.toString());
    params.set('getAuto', getAuto.toString());
    return this._http.get(`api/GETNewInspection/GetCrackObsList`, { search: params }).share()
      .map((response: Response) => <componentListsVM[]>response.json()).catch(this.handleError);
  }

  public saveShapes(shapes: DrawShape[]): Observable<ResponseMessage> {
    return this._http.post('Api/GETComponent/ManageSchematicComponentsRecognition', shapes).share().map(
      (response: Response) => <ResponseMessage>response.json()).catch(this.handleError);
  }

  public saveShapeLocation(location: Locations[]): Observable<ResponseMessage> {
    return this._http.post('Api/GETComponent/SaveShapeLocation', location).share().map(
      (response: Response) => <ResponseMessage>response.json()).catch(this.handleError);
  }

  public getSchematicComponentsRecognitionsDetails(schematicId: number, implementId: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('schematicId', schematicId.toString());
    params.set('implementId', implementId.toString());
    return this._http.get(`api/GETComponent/GetSchematicComponentsRecognitionsDetails`, { search: params }).share()
      .map((response: Response) => <DrawShape[]>response.json()).catch(this.handleError);
  }

  public getCrackStatuses() {
    return this._http.get(`api/GETComponent/GetCrackStatuses`).share()
      .map((response: Response) => <CrackStatusVM[]>response.json()).catch(this.handleError);
  }

 public UpdateInspectionStatusToHide(inspectionId: number, getAuto: number) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('inspectionId', inspectionId.toString());
    params.set('getAuto', getAuto.toString());
    return this._http.get(`api/GETInspection/UpdateInspectionStatusToHide`, { search: params }).share()
      .map((response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public getInspMaintananceActions(implementId: number): Observable<string> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', implementId.toString());
    return this._http.get('api/Implement/GetInspMaintananceActions', { search: params }).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public updateMaintainanceActionData(implementId: number): Observable<boolean> {
    const request = {
      ImplementId: implementId
    };
    return this._http.post('api/Implement/UpdateMaintainanceActionData', request).share()
      .map((response: Response) => <boolean>response.json())
      .catch(this.handleError);
  }

  public hideSchematic(implementId: number, schematicId: number, IsHidden: boolean) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', implementId.toString());
    params.set('SchematicId', schematicId.toString());
    params.set('IsHidden', IsHidden.toString());
    return this._http.get('api/Implement/Implement_HideSchematic', { search: params })
      .map((response: Response) => response.text())
      .catch(this.handleError);
  }


}
